import React, { useState } from "react";
import { Modal, Form, Input, Button } from "antd";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { getConfig } from "../../../../config";
import { dietModeService } from "../../../../services/settings-services";
import { dietModeActions } from "../../../../store/slices/settings-slices";

const DietModeCreateModal = ({ isOpen, setIsOpen, dietTypeId }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const { cityCode } = getConfig();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      await dietModeService.createDietMode({
        name: {
          en: values.en,
          ru: values.ru,
          ar: values.ar,
          ge: values.ge,
        },
        description: {
          en: values.en_description,
          ru: values.ru_description,
          ar: values.ar_description,
          ge: values.ge_description,
        },
        dietTypeId: dietTypeId,
      });
      dispatch(dietModeActions.changeTrigger());
      toast.success(t("Diet mode created successfully"));
      setIsOpen(false);
      form.resetFields();
    } catch (error) {
      console.error("Error creating diet mode:", error);
      toast.error(t("Error creating diet mode"));
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setIsOpen(false);
    form.resetFields();
  };

  return (
    <Modal
      title={t("Create New Diet Mode")}
      open={isOpen}
      onCancel={handleCancel}
      footer={null}
      width={600}
      destroyOnClose
      maskClosable={!loading}
      closable={!loading}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        autoComplete="off"
        data-lpignore="true"
        data-form-type="other"
      >
        <Form.Item
          label={`${t("Diet Mode Name")} (English)`}
          name="en"
          rules={[
            {
              required: true,
              message: t(
                "This field is required / Это поле обязательно / ეს ველი აუცილებელია"
              ),
            },
          ]}
        >
          <Input placeholder={t("Enter diet mode name in English")} />
        </Form.Item>

        <Form.Item
          label={`${t("Diet Mode Name")} (Русский)`}
          name="ru"
          rules={[
            {
              required: true,
              message: t(
                "This field is required / Это поле обязательно / ეს ველი აუცილებელია"
              ),
            },
          ]}
        >
          <Input placeholder={t("Enter diet mode name in Russian")} />
        </Form.Item>

        <Form.Item
          label={`${t("Description")} (English)`}
          name="en_description"
          rules={[
            {
              required: true,
              message: t(
                "This field is required / Это поле обязательно / ეს ველი აუცილებელია"
              ),
            },
          ]}
        >
          <Input.TextArea
            placeholder={t("Enter description in English")}
            rows={3}
          />
        </Form.Item>

        <Form.Item
          label={`${t("Description")} (Русский)`}
          name="ru_description"
          rules={[
            {
              required: true,
              message: t(
                "This field is required / Это поле обязательно / ეს ველი აუცილებელია"
              ),
            },
          ]}
        >
          <Input.TextArea
            placeholder={t("Enter description in Russian")}
            rows={3}
          />
        </Form.Item>

        {cityCode === "UAE" ? (
          <>
            <Form.Item
              label={`${t("Diet Mode Name")} (العربية)`}
              name="ar"
              rules={[
                {
                  required: true,
                  message: t(
                    "This field is required / Esto поле обязательно / ეს ველი აუცილებელია"
                  ),
                },
              ]}
            >
              <Input placeholder={t("Enter diet mode name in Arabic")} />
            </Form.Item>
            <Form.Item
              label={`${t("Description")} (العربية)`}
              name="ar_description"
              rules={[
                {
                  required: true,
                  message: t(
                    "This field is required / Esto поле обязательно / ეს ველი აუცილებელია"
                  ),
                },
              ]}
            >
              <Input.TextArea
                placeholder={t("Enter description in Arabic")}
                rows={3}
              />
            </Form.Item>
          </>
        ) : (
          <>
            <Form.Item
              label={`${t("Diet Mode Name")} (ქართული)`}
              name="ge"
              rules={[
                {
                  required: true,
                  message: t(
                    "This field is required / Это поле обязательно / ეს ველი აუცილებელია"
                  ),
                },
              ]}
            >
              <Input placeholder={t("Enter diet mode name in Georgian")} />
            </Form.Item>
            <Form.Item
              label={`${t("Description")} (ქართული)`}
              name="ge_description"
              rules={[
                {
                  required: true,
                  message: t(
                    "This field is required / Esto поле обязательно / ეს ველი აუცილებელია"
                  ),
                },
              ]}
            >
              <Input.TextArea
                placeholder={t("Enter description in Georgian")}
                rows={3}
              />
            </Form.Item>
          </>
        )}

        <Form.Item style={{ marginBottom: 0, marginTop: "1rem" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "0.5rem",
            }}
          >
            <Button onClick={handleCancel} disabled={loading}>
              {t("Cancel")}
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              disabled={loading}
            >
              {t("Create")}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export { DietModeCreateModal };
